import AntDropdown, {
  DropdownProps as AntDropdownProps,
} from "antd/es/dropdown";
import { css, useTheme } from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc";
import React from "react";
import MobileDropdown from "common/Dropdown/MobileDropdown";

export interface DropdownProps extends Omit<AntDropdownProps, "onOpenChange"> {
  title?: string;
  children?: React.JSX.Element;
  onOpenChange?: (
    open: boolean,
    info?: {
      source: "trigger" | "menu";
    }
  ) => void;
  mobileCloseOnSelect?: boolean;
}

const Dropdown = ({ mobileCloseOnSelect, ...props }: DropdownProps) => {
  const theme = useTheme();
  const bottomNavigatorData = useBottomNavigator();

  if (bottomNavigatorData.baseShouldDisplay) {
    return <MobileDropdown {...props} closeOnSelect={mobileCloseOnSelect} />;
  }

  return (
    <AntDropdown
      {...props}
      classNames={{ root: theme.isDarkMode ? "dark-mode" : "" }}
    />
  );
};

export default Dropdown;

export const dropdownStyles = css`
  .ant-dropdown.dark-mode {
    .ant-dropdown-menu {
      background-color: ${(p) => p.theme.colors.mediumBgColor} !important;

      .ant-dropdown-menu-item {
        color: ${(p) => p.theme.colors.primaryText};

        &:hover {
          background: ${(p) => p.theme.colors.lightestGrey};
        }
      }
    }
  }

  .ant-dropdown {
    .ant-dropdown-menu {
      .ant-dropdown-menu-item.warning {
        color: ${(p) => p.theme.colors.yellow};

        &:hover {
          background: ${(p) => p.theme.colors.yellow};
          color: ${(p) => p.theme.colors.cardBgColor};
        }
      }

      .ant-dropdown-menu-item.success {
        color: ${(p) => p.theme.colors.green};

        &:hover {
          background: ${(p) => p.theme.colors.green};
          color: ${(p) => p.theme.colors.cardBgColor};
        }
      }

      .ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
        color: ${(p) => p.theme.colors.red};

        &:hover {
          background: ${(p) => p.theme.colors.red};
          color: ${(p) => p.theme.colors.cardBgColor};
        }
      }

      .ant-dropdown-menu-item.invalid {
        opacity: 0.3;
      }

      .ant-dropdown-menu-title-content {
        text-align: left;
      }
    }
  }

  .mobile-dropdown {
    .mobile-dropdown-menu-item.danger {
      color: ${(p) => p.theme.colors.red};
    }

    .mobile-dropdown-menu-item.warning {
      color: ${(p) => p.theme.colors.yellow};
    }

    .mobile-dropdown-menu-item.success {
      color: ${(p) => p.theme.colors.green};
    }

    .mobile-dropdown-menu-item.invalid {
      opacity: 0.5;
    }
  }
`;
